export const BACKEND_URL = "https://api.cadenceprotocol.io/api/";
